import { cn } from "../lib/utils.ts"

/*
 * shadcn/ui Kbd: a 20 px key cap, 12 px weight 500, the control fill with a heavier bottom edge (typography.md).
 * The edge and fill are washes of the text colour, so the cap reads the same in light and dark
 * (the plain border token matches the dark raised surface and left a bare glyph there).
 */
function Kbd({ className, ...props }: React.ComponentProps<"kbd">) {
  return (
    <kbd
      data-slot="kbd"
      className={cn(
        "kbd-key pointer-events-none inline-flex h-5 w-fit min-w-5 select-none items-center justify-center gap-1 rounded-control border border-fg/12 bg-fg/5 px-1 font-sans text-caption text-fg-subtle",
        "[&_svg:not([class*='size-'])]:size-3",
        className
      )}
      {...props}
    />
  )
}

function KbdGroup({ className, ...props }: React.ComponentProps<"div">) {
  return (
    <kbd
      data-slot="kbd-group"
      className={cn("inline-flex items-center gap-1", className)}
      {...props}
    />
  )
}

export { Kbd, KbdGroup }
